export const UPDATE_STATEMENT_PROCESS_FAILURE = 'UPDATE_STATEMENT_PROCESS_FAILURE';

export const updateStatementProcessFailure = error => ({
    type: UPDATE_STATEMENT_PROCESS_FAILURE,
    payload: error,
    error: true,
});
